import {ObjectDTO} from "../object-dto";
import PointDeLivraisonRegroupementPlatDTO from "./point-de-livraison-regroupement-plat-dto";
import {UniteDeProductionDTO} from "../unite-de-production-dto";
import {ProduitDTO} from "../produit-dto";

export default class RegroupementPlatDTO extends ObjectDTO {
  uniteDeProduction: UniteDeProductionDTO[] = [];
  pointDeLivraisons: PointDeLivraisonRegroupementPlatDTO[] = [];
  plats: ProduitDTO[] = [];
}

